import {certificateSvg as Icon__small__certificateSvg} from '../Icon__small/Icon__small--certificate.js';

export var certificate = {
  name: 'certificate',
  category: 'icon',
  colorable: true,
  svg: Icon__small__certificateSvg,
};
